import { Eye, EyeSlash } from "@phosphor-icons/react";
import { forwardRef, useState } from "react";

import { Input, type InputProps } from "common/components/ui/Input";

const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ maxLength, rightComponent, ...rest }, ref) => {
    const [isPasswordHidden, setIsPasswordHidden] = useState(true);

    return (
      <Input
        {...rest}
        type={isPasswordHidden ? "password" : "text"}
        ref={ref}
        rightComponent={
          <>
            <button
              type="button"
              onClick={() => setIsPasswordHidden(!isPasswordHidden)}
            >
              {isPasswordHidden ? <EyeSlash /> : <Eye />}
            </button>
            {rightComponent}
          </>
        }
      />
    );
  },
);
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
